import { ApiClient, AuthApi } from "sandpiper_api";
import jwt_decode from "jwt-decode";
import log from "@/utils/logger";

const state = () => ({
    accessToken: null,
    jwtPayload: null
});

// const methods = {
//     hasRole(state, role)
//     {
//         if (state.jwtPayload === null) return false;
//         let userRoles = state.jwtPayload.secRoles.split(",") || [];
//         return userRoles.includes(role);
//     }
// }

const getters = {
    isAuthenticated(state)
    {
        return state.jwtPayload !== null && new Date() < new Date(state.jwtPayload.exp * 1000)
    }
}

const actions = {
    refreshAccessToken(context)
    {
        return new AuthApi().refreshTokens({ invalidateToken: false })
            .then(response =>
            {
                log.info("Successfully requested new access token"); // Don't log access token!
                return context.dispatch("login", response.access_token).then(() => response);
            });
    },
    login(context, accessToken)
    {
        context.commit("setJwtToken", accessToken);

        if (accessToken)
        {
            const jwtPayload = jwt_decode(accessToken);
            context.commit("setJwtPayload", jwtPayload);
        }
    },
    logout(context)
    {
        context.commit("clearToken");
    }
}

const mutations = {
    setJwtToken(state, accessToken)
    {
        ApiClient.instance.authentications["oAuth2Password"].accessToken = accessToken;
        state.accessToken = accessToken;
    },
    setJwtPayload(state, jwtPayload)
    {
        state.jwtPayload = jwtPayload;
    },
    clearToken(state)
    {
        ApiClient.instance.authentications["oAuth2Password"].accessToken = null;
        state.accessToken = null;
        state.jwtPayload = null;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}